import sizeIllust from '@/assets/landing/spec-size.webp'

import {
  SizeIllust,
  SpecBody,
  SpecContainer,
  SpecHeading,
  SpecLabelCell,
  SpecRow,
  SpecTable,
  SpecValueCell,
  SpecValueLine,
} from './styles'

const SPEC_ROWS = [
  { label: '사이즈', tone: 'default', values: ['60cm * 75cm * 8cm'] },
  { label: '구조', tone: 'default', values: ['상단 지퍼백 내장'] },
  { label: '두께', tone: 'default', values: ['비침없는 두꺼운 재질'] },
  { label: '단점', tone: 'cons', values: ['과적 시 지퍼 열림', '끝부분 날카로움 (잘라서 사용 권장)'] },
  { label: '장점', tone: 'pros', values: ['냄새 차단 UP · 밀봉력 우수', '넉넉한 사이즈 · 튼튼한 재질'] },
] as const

export function SpecSection() {
  return (
    <SpecContainer>
      <SpecHeading>밀봉비닐 상세규격</SpecHeading>
      <SpecBody>
        <SizeIllust
          src={sizeIllust}
          alt='밀봉비닐 사이즈 60cm x 75cm x 8cm'
          width={208}
          height={228}
          loading='lazy'
          decoding='async'
        />
        <SpecTable>
          {SPEC_ROWS.map((row) => (
            <SpecRow key={row.label}>
              <SpecLabelCell tone={row.tone}>{row.label}</SpecLabelCell>
              <SpecValueCell tone={row.tone}>
                {row.values.map((value) => (
                  <SpecValueLine
                    key={value}
                    tone={row.tone}
                  >
                    {value}
                  </SpecValueLine>
                ))}
              </SpecValueCell>
            </SpecRow>
          ))}
        </SpecTable>
      </SpecBody>
    </SpecContainer>
  )
}
